import * as React from 'react';
import { visualizationUpdater } from '@mentimeter/visualizations';

interface PropsT {
  updateFn: () => Promise<any>;
}

export const VisualizationUpdater = ({ updateFn }: PropsT) => {
  React.useEffect(() => {
    const updater = visualizationUpdater();
    updater(updateFn);
  }, [updateFn]);
  return null;
};
